import _jsx from "@babel/runtime/helpers/jsx";
import React, { useState } from 'react';
import { Image } from 'reaxl';
export default function InventoryListingImagePreviews(_ref) {
  let {
    images
  } = _ref;
  const [hasImageErrors, setHasImageErrors] = useState(false);
  const handleImageError = () => setHasImageErrors(true);

  // Skips first image in array as it is the primary image, instead grabs the next three
  const previewImages = images.slice(1, 4);
  const middlePreviewImageStyles = {
    borderLeft: '1px solid white',
    borderRight: '1px solid white'
  };
  if (hasImageErrors || previewImages?.length !== 3) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: "display-flex",
    style: {
      borderTop: '1px solid white'
    }
  }, void 0, previewImages.map((image, index) => {
    delete image.width;
    delete image.height;
    return /*#__PURE__*/React.createElement(Image, Object.assign({}, image, {
      key: image.src,
      onError: handleImageError,
      className: "img-responsive-scale flex-grow",
      style: {
        width: '33.3%',
        ...(index === 1 ? middlePreviewImageStyles : {})
      }
    }));
  }));
}